/* eslint-disable comma-dangle */
/* eslint-disable quotes */
const mockThread = [{
  "chunks": ["markdown\n"],
  "role": "user"
}, {
  "chunks": [{
    "type": "text",
    "text": "Markdown\n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "Header 1  \n"
  }, {
    "type": "text",
    "text": "========  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "Header 2  \n"
  }, {
    "type": "text",
    "text": "--------  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "### Header 3 ###  \n"
  }, {
    "type": "text",
    "text": "#### Header 4 ####  \n"
  }, {
    "type": "text",
    "text": "##### Header 5 #####  \n"
  }, {
    "type": "text",
    "text": "###### Header 6 ######   \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "### Phrase Emphasis   \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "*italic*   \n"
  }, {
    "type": "text",
    "text": "**bold**  \n"
  }, {
    "type": "text",
    "text": "_italic_   \n"
  }, {
    "type": "text",
    "text": "__bold__  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "### Links  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "An [example](https://www.gmail.com/ \"Title\")  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "### Images  \n"
  }, {
    "type": "text",
    "text": "![alt text](https://picsum.photos/id/104/800/600 \"Title\")  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "### Lists  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "1.  Foo  \n"
  }, {
    "type": "text",
    "text": "2.  Bar  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "*   A list item.  \n"
  }, {
    "type": "text",
    "text": "    With multiple paragraphs.  \n"
  }, {
    "type": "text",
    "text": "*   Bar  \n"
  }, {
    "type": "text",
    "text": "*   Abacus  \n"
  }, {
    "type": "text",
    "text": "    * answer  \n"
  }, {
    "type": "text",
    "text": "*   Bubbles  \n"
  }, {
    "type": "text",
    "text": "    1.  bunk  \n"
  }, {
    "type": "text",
    "text": "    2.  bupkis  \n"
  }, {
    "type": "text",
    "text": "        * BELITTLER  \n"
  }, {
    "type": "text",
    "text": "    3. burper  \n"
  }, {
    "type": "text",
    "text": "*   Cunning  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "### Blockquotes  \n"
  }, {
    "type": "text",
    "text": "> Email-style angle brackets  \n"
  }, {
    "type": "text",
    "text": "> are used for blockquotes.  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "> > And, they can be nested.  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "> ### Headers in blockquotes  \n"
  }, {
    "type": "text",
    "text": ">   \n"
  }, {
    "type": "text",
    "text": "> * You can quote a list.  \n"
  }, {
    "type": "text",
    "text": "> * Etc.  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "### Code Spans  \n"
  }, {
    "type": "text",
    "text": "`<code>` spans are delimited by backticks.  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "You can include literal backticks like `` `this` ``.  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "### Preformatted Code Blocks  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "This is a normal paragraph.  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "    This is a preformatted  \n"
  }, {
    "type": "text",
    "text": "    code block.  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "```  \n"
  }, {
    "type": "text",
    "text": "function sum(a, b) {  \n"
  }, {
    "type": "text",
    "text": "  return a + b;  \n"
  }, {
    "type": "text",
    "text": "}  \n"
  }, {
    "type": "text",
    "text": "```  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "### Horizontal Rules  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "---  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "* * *  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "- - - -   \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "### Manual Line Breaks  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }, {
    "type": "text",
    "text": "Roses are red,   \n"
  }, {
    "type": "text",
    "text": "Violets are blue.  \n"
  }, {
    "type": "text",
    "text": "  \n"
  }],
  "role": "assistant"
}, {
  "chunks": ["events\n"],
  "role": "user"
}, {
  "chunks": ["Fammi pensare...\n", "ecco una lista di eventi:\n", {
    "type": "eventItem",
    "id": "xxxx",
    "title": "Percorri la Bicipolitana di Pesaro con i tuoi bambini",
    "abstract": "Un’esperienza da non perdere se visiterai la città con i bambini, noleggia la tua bici e esplora Pesaro.",
    "place": "Pesaro",
    "url": "https://design.wslabs.it/llm",
    "image": "https://design.wslabs.it/llm/default/bicipolitana.jpg",
    "date": "15-16 giugno 2024",
    "time": "ore 20:00"
  }, {
    "type": "eventItem",
    "id": "100",
    "title": "Non perderti The Magic Castle di Gradara!",
    "abstract": "The Magic Castle, l’evento per famiglie che ogni estate trasforma magicamente lo splendido borgo di Gradara.",
    "place": "Gradara",
    "url": "https://design.wslabs.it/llm",
    "image": "https://design.wslabs.it/llm/default/gradara.jpg",
    "date": "15-16 giugno 2024",
    "time": "ore 20:00"
  }, {
    "type": "eventItem",
    "id": "xxxx",
    "title": "Trekking e panorami mozzafiato al San Bartolo",
    "abstract": "Scendendo lungo la costa Adriatica, si erge il San Bartolo, un meraviglioso parco naturale affacciato sul mare.",
    "place": "Parco San Bartolo",
    "url": "https://design.wslabs.it/llm",
    "image": "https://design.wslabs.it/llm/default/san-bartolo.jpg",
    "date": "15-16 giugno 2024",
    "time": "ore 20:00"
  }, "Per qualunque altra cosa sono qui. 🙂\n"],
  "role": "assistant"
}, {
  "chunks": ["event\n"],
  "role": "user"
}, {
  "chunks": ["Dammi un momento...\n", "ecco un evento:\n", {
    "type": "event",
    "id": "234",
    "title": "Rossini Virtual 'Experience': esplora casa Rossini in AR",
    "abstract": "Lasciati guidare dallo stesso Gioacchino nella sua casa e scopri la sua storia attraverso giocosi aneddoti in AR.",
    "place": "Pesaro",
    "url": "https://design.wslabs.it/llm",
    "image": "https://picsum.photos/id/103/800/600",
    "date": "15-16 giugno 2024",
    "time": "ore 20:00"
  }, "Serve altro?\n"],
  "role": "assistant"
}, {
  "chunks": ["pois\n"],
  "role": "user"
}, {
  "chunks": ["Bene!\n", "ecco alcuni punti di interesse:\n", {
    "type": "poiItem",
    "id": "111",
    "title": "Title",
    "abstract": "Lorem ipsum dolor sit amet.",
    "place": "Place",
    "image": "https://picsum.photos/id/102/800/600",
    "url": "https://design.wslabs.it/llm",
    "time": "time"
  }, {
    "type": "poiItem",
    "id": "222",
    "title": "Title",
    "abstract": "Lorem ipsum dolor sit amet.",
    "place": "Place",
    "image": "https://picsum.photos/id/101/800/600",
    "url": "https://design.wslabs.it/llm"
  }, "Serve altro? 🙂\n"],
  "role": "assistant"
}, {
  "chunks": ["poi\n"],
  "role": "user"
}, {
  "chunks": ["Certo!\n", "ecco un punto di interesse:\n", {
    "type": "poiItem",
    "id": "111",
    "title": "Title",
    "abstract": "Lorem ipsum dolor sit amet.",
    "place": "Place",
    "image": "https://design.wslabs.it/llm/default/rossini.jpg",
    "url": "https://design.wslabs.it/llm",
    "time": "time"
  }, "Serve altro? 🙂\n"],
  "role": "assistant"
}, {
  "chunks": ["tripadvisor\n"],
  "role": "user"
}, {
  "chunks": ["Dammi un secondo...\n", "ecco alcuni ristoranti per te:\n", {
    "type": "tripadvisor",
    "id": "xxxx",
    "title": "L'Angolo di Mario",
    "rating": 4.8,
    "reviews": 2276,
    "priceRange": "€€-€€€",
    "cuisine": "Italiana, Pesce, Mediterranea",
    "address": "Via Nazario Sauro, 61100 Pesaro PU",
    "url": "https://design.wslabs.it/llm",
    "book": "https://design.wslabs.it/llm",
    "image": "https://design.wslabs.it/llm/default/tripadvisor-01.jpg"
  }, {
    "type": "tripadvisor",
    "id": "xxxx",
    "title": "L'Amo Osteria di Mare",
    "rating": 4.2,
    "reviews": 287,
    "priceRange": "€€-€€€",
    "cuisine": "Italiana, Pesce, Mediterranea",
    "address": "Via Venturini 4/6, 61121 Pesaro PU",
    "url": "https://design.wslabs.it/llm",
    "book": "https://design.wslabs.it/llm",
    "image": "https://design.wslabs.it/llm/default/tripadvisor-02.jpg"
  }],
  "role": "assistant"
}];

export { mockThread };
//# sourceMappingURL=mock-thread.default.js.map
